import { render, staticRenderFns } from "./ProductEditMore.vue?vue&type=template&id=789623bd&scoped=true&"
import script from "./ProductEditMore.vue?vue&type=script&lang=js&"
export * from "./ProductEditMore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "789623bd",
  null
  
)

export default component.exports